import React, { useEffect } from 'react'
import filter from 'lodash/filter'

import SearchDropdown from '@SiteComponents/SearchDropdown'

interface LanguageSettingsRowProps {
  readonly availableOriginalLanguages: string[]
  readonly availableTargetLanguages: string[]
  readonly originalLanguage: string
  readonly targetLanguage: string
  readonly hasLoadedSuccessfully: boolean
  onOriginalChange(lang: string): void
  onTargetChange(lang: string): void
  setOriginalLanguage(lan: string): void
  setTargetLanguage(lan: string): void
}

const LanguageSettingsRow: React.FC<LanguageSettingsRowProps> = (props) => {
  const {
    hasLoadedSuccessfully,
    availableOriginalLanguages,
    availableTargetLanguages,
    originalLanguage,
    targetLanguage,
    onOriginalChange,
    onTargetChange,
    setOriginalLanguage,
    setTargetLanguage,
  } = props

  const availableTargetLanguagesWithoutOriginalLanguage = filter(availableTargetLanguages, availableTargetLanguage => availableTargetLanguage !== originalLanguage)

  useEffect(() => {
    if (hasLoadedSuccessfully && !availableOriginalLanguages.includes(originalLanguage)) {
      setOriginalLanguage('')
    }
  }, [availableOriginalLanguages, originalLanguage])

  useEffect(() => {
    if (hasLoadedSuccessfully && !availableTargetLanguagesWithoutOriginalLanguage.includes(targetLanguage)) {
      setTargetLanguage('')
    }
  }, [availableTargetLanguagesWithoutOriginalLanguage, targetLanguage])

  return (
    <div className="QuickStart__language-section">
      <h2 className="QuickStart__section-heading">Language settings</h2>
      <div className="QuickStart__language-row">
        <div className="QuickStart__language-dropdown-wrapper">
          <label className="QuickStart__language-label">Original Language</label>
          <div
            className="QuickStart__language-dropdown-inner-wrapper"
            id="quickstart_language_dropdown-inner-wrapper-original"
          >
            <SearchDropdown
              availableOptions={availableOriginalLanguages}
              selectedOption={originalLanguage}
              classNameForClickOutsideListener="QuickStart__language-original-language-dropdown"
              idNameOfParentContainer="quickstart_language_dropdown-inner-wrapper-original"
              classNameOfContainerToMakeUnscrollable="Onboarding"
              placeholderText="Original Language"
              setSelectedOption={onOriginalChange}
            />
          </div>
        </div>
        <div className="QuickStart__language-dropdown-wrapper">
          <label className="QuickStart__language-label">Target Language</label>
          <div
            className="QuickStart__language-dropdown-inner-wrapper"
            id="quickstart_language_dropdown-inner-wrapper-target"
          >
            <SearchDropdown
              availableOptions={availableTargetLanguagesWithoutOriginalLanguage}
              selectedOption={targetLanguage}
              classNameForClickOutsideListener="QuickStart__language-target-language-dropdown"
              idNameOfParentContainer="quickstart_language_dropdown-inner-wrapper-target"
              classNameOfContainerToMakeUnscrollable="Onboarding"
              placeholderText="Target Language"
              setSelectedOption={onTargetChange}
              />
            </div>
        </div>
      </div>
    </div>
  )
}

export default LanguageSettingsRow
